import { defineStore } from 'pinia'
// import md5 from 'md5'
import { AbTest, AbTestVariant } from '~/models/AbTest/AbTest'

export const useAbTestStore = defineStore('abTest', {
    state: () => ({
        abTests: [] as AbTestVariant[],
    }),
    actions: {
        setAbTestNames(abTests: AbTest[]) {
            try {
                // A/B testing is non-essential (analytics) storage. Under the Czech opt-in
                // rules the persistent identifier must not be written before consent — until
                // then variants live in memory only for the current session.
                const consentGranted = isAnalyticsConsentGranted()
                const abTestsCookie = useAbTestCookie()
                const abTestsFromLocalStorage =
                    consentGranted && typeof localStorage !== 'undefined' ? JSON.parse(localStorage.getItem('abTests') || 'null') : null
                const storedAbTests: AbTestVariant[] = (consentGranted ? abTestsCookie.value : null) || abTestsFromLocalStorage || []
                // the backend sends only the currently valid tests - drop stored variants of ended ones, otherwise
                // returning visitors keep their old variant forever (the cookie is re-written on every visit)
                const validAbTestNames = (abTests || []).map((abTest) => abTest.name)
                this.abTests = storedAbTests.filter((abTest) => validAbTestNames.includes(abTest.name))

                for (let i = 0; i < abTests?.length; i++) {
                    let found = false
                    for (let j = 0; j < this.abTests.length; j++) {
                        if (abTests[i].name === this.abTests[j].name) {
                            found = true
                        }
                    }

                    if (!found) {
                        // const selectedVariant = Number.parseInt(md5(abTests[i].name + headers['user-agent'] + headers['x-forwarded-for']).substring(0, 4), 16) % abTests[i].variantsCount

                        this.abTests.push({
                            name: abTests[i].name,
                            selectedVariant: Math.floor(Math.random() * abTests[i].variantsCount),
                        })
                    }
                }

                if (consentGranted) {
                    localStorage?.setItem('abTests', JSON.stringify(this.abTests))
                    abTestsCookie.value = this.abTests
                }
            } catch (e) {}
        },

        getVariant(abTestName: string): number | null {
            for (let i = 0; i < this.abTests.length; i++) {
                if (this.abTests[i].name === abTestName) {
                    return this.abTests[i].selectedVariant
                }
            }

            return null
        },
    },
})
